<template>
  <a href="https://twitter.com/intent/tweet?text=🎨  Flat UI Colors 2 - 280 handpicked colors for your projects 📝 %20http%3A//flatuicolors.com%20via%20%40ahmetsulek&related=ahmetsulek" class="promoter-container" target="_blank">
    💞&nbsp;&nbsp;&nbsp;&nbsp;Tweet and share your love for Flat UI Colors &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;
    <div class="tweet">
      <i></i>
      <span>Tweet</span>
    </div>
  </a>
</template>

<script>
export default {
  name: "Promoter",
  components: {},
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.promoter-container {
  &:hover .tweet i {
    animation: tweet 0.6s steps(7) infinite;
  }
  .tweet {
    position: relative;
    display: inline-block;
    height: 20px;
    padding: 0 6px;
    color: #fff;
    cursor: pointer;
    background-color: #1b95e0;
    border-radius: 3px;
    box-sizing: border-box;
    text-decoration: none;
    transition: background-color 0.2s ease;
    transform: scale(1.2);
  }
  .tweet i {
    position: relative;
    top: 4px;
    display: inline-block;
    vertical-align: top;
    width: 18px;
    height: 11px;
    background-image: url("https://andreasstorm.com/lib/tweet.svg");
    background-repeat: no-repeat;
    background-position: 0 0;
    background-size: 144px 11px;
  }
  .tweet span {
    position: relative;
    top: 4px;
    left: -2px;
    vertical-align: top;
    font-family: "Helvetica Neue", Arial, sans-serif;
    font-weight: 500;
    font-size: 11px;
  }
  @keyframes tweet {
    100% {
      background-position: -126px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Promoter.vue